import { Component, Vue } from 'vue-property-decorator'

@Component
export default class ScrollToTop extends Vue {
    public scrollTo(height: number) {
        const page: any = document.getElementById('tkn-body')
        this.$nextTick(() => {
            page.scrollIntoView({
                top: height,
                behavior: 'smooth'
            })
        })
    }
}